import React from 'react';
import s from './styles.module.css'
import Wrapper from '../../components/wrapper';
import HeaderTitle from '../../components/header_title';

const CookiePolicy = () => {
  return (
    <div className={s.main}>
      <Wrapper>
        <HeaderTitle/>
        <h1>Cookiepolitik</h1>

        <p>
          Denne hjemmeside anvender cookies for at sikre korrekt funktion,
          forbedre brugeroplevelsen og indsamle anonym statistik om brugen af
          hjemmesiden.
        </p>

        <h2>Hvad er cookies?</h2>
        <p>
          Cookies er små tekstfiler, som gemmes på din enhed, når du besøger en
          hjemmeside. De hjælper med at huske dine præferencer og gør det muligt
          at forbedre hjemmesidens funktionalitet.
        </p>

        <h2>Hvordan bruger vi cookies?</h2>
        <p>
          Vi anvender cookies til at sikre, at hjemmesiden fungerer korrekt,
          analysere trafik og forbedre indhold og brugeroplevelse.
        </p>

        <h2>Typer af cookies</h2>

        <h3>Nødvendige cookies</h3>
        <p>
          Disse cookies er nødvendige for, at hjemmesiden fungerer korrekt og kan
          ikke deaktiveres i vores systemer.
        </p>

        <h3>Analysecookies</h3>
        <p>
          Analysecookies hjælper os med at forstå, hvordan besøgende anvender
          hjemmesiden. Oplysningerne bruges udelukkende til statistik og til at
          forbedre hjemmesiden.
        </p>

        <h2>Google Analytics</h2>
        <p>
          Vi anvender Google Analytics til at analysere, hvordan besøgende bruger
          hjemmesiden. Google Analytics benytter cookies til at indsamle
          oplysninger såsom besøgte sider, besøgstid, enhedstype og generelle
          brugsdata.
        </p>

        <p>
          De indsamlede oplysninger anvendes udelukkende til statistiske formål
          og til at forbedre hjemmesidens indhold og funktionalitet. Vi anvender
          ikke Google Analytics til at identificere individuelle brugere.
        </p>

        <h3>Funktionscookies</h3>
        <p>
          Disse cookies husker dine valg og præferencer for at give en mere
          personlig brugeroplevelse.
        </p>

        <h2>Administration af cookies</h2>
        <p>
          Du kan til enhver tid administrere eller slette cookies via
          indstillingerne i din browser. Bemærk, at visse funktioner på
          hjemmesiden muligvis ikke fungerer korrekt, hvis cookies deaktiveres.
        </p>

        <h2>Ændringer af cookiepolitikken</h2>
        <p>
          Vi forbeholder os retten til at opdatere denne cookiepolitik.
          Den nyeste version vil altid være tilgængelig på denne side.
        </p>
      </Wrapper>
    </div>
  );
};

export default CookiePolicy;
